/**
 * In-memory ring buffer of recent client-side errors, attached to bug
 * reports so triage has real diagnostics to reason over. Fed by
 * exception-handler.ts (`report()`) and GlobalErrorListener. Never
 * persisted; resets on page load.
 */

export interface BufferedClientError {
  message: string;
  name?: string;
  /** First ~600 chars of the stack — enough to locate, small enough to store. */
  stackHead?: string;
  filename?: string;
  /** ISO timestamp of capture. */
  at: string;
}

const MAX_BUFFER = 20;
const MAX_STACK_HEAD = 600;

const buffer: BufferedClientError[] = [];

export function recordClientError(error: unknown, filename?: string): void {
  if (typeof window === 'undefined') return;
  try {
    const err = error instanceof Error ? error : new Error(String(error));
    buffer.push({
      message: String(err.message ?? '').slice(0, 500),
      name: err.name,
      stackHead: err.stack ? err.stack.slice(0, MAX_STACK_HEAD) : undefined,
      filename,
      at: new Date().toISOString(),
    });
    if (buffer.length > MAX_BUFFER) buffer.splice(0, buffer.length - MAX_BUFFER);
  } catch {
    // Telemetry must never throw.
  }
}

export function getRecentClientErrors(n = 10): BufferedClientError[] {
  return buffer.slice(-n);
}
